import { convertEnum } from "../enumUtil";

export const EBusinessPost = {
  admin: "良信管理员",
  business: "良信-智拓业务部",
  software: "良信-软件研发部",
  factoryService: "良信-盘厂服务部",
  productLine: "良信-产品线",
  other: "良信-其他",
  supplierPartner: "良信供应商伙伴",
};

export const [MBusinessPost, OBusinessPost] = convertEnum([
  [EBusinessPost.admin, EBusinessPost.admin],
  [EBusinessPost.business, EBusinessPost.business],
  [EBusinessPost.software, EBusinessPost.software],
  [EBusinessPost.factoryService, EBusinessPost.factoryService],
  [EBusinessPost.productLine, EBusinessPost.productLine],
  [EBusinessPost.other, EBusinessPost.other],
  [EBusinessPost.supplierPartner, EBusinessPost.supplierPartner],
]);

export const EMemberIdentityType = {
  // factory: 1,
  business: 2,
  admin: 3,
};

export const [MMemberIdentityType, OMemberIdentityType] = convertEnum([
  // [EMemberIdentityType.factory, "盘厂"],
  [EMemberIdentityType.business, "业务专员"],
  [EMemberIdentityType.admin, "管理员"],
]);

export const ELwsDealer = {
  beisheng: "安徽贝升电气有限公司",
  liangxian: "江苏良贤电器有限公司",
  rongge: "江苏容格科技有限公司",
  yiteng: "上海弈藤实业有限公司",
  tianjun: "苏州天骏输配电有限公司",
  yanzhiyu: "安徽燕之语家居科技有限公司",
  huashi: "杭州华世电气有限公司",
  hexinda: "江西合信达智能电气有限公司",
  yixing: "宁波易星电力有限公司",
  huayao: "台州市华耀电气有限公司",
  yingxin: "温州赢信科技有限公司",
  jiacheng: "浙江加乘电气有限公司",
  junwei: "浙江军威电气科技有限公司",
  chengyan: "河北诚砚智能设备有限公司",
  fukang: "吉林福康电器有限公司",
  liyang: "立阳科技（北京）有限公司",
  zhongzhida: "内蒙古众致达供应链管理有限公司",
  beijingRongqiao: "融桥科技（北京）有限公司",
  shenyangRongqiao: "沈阳融桥科技有限公司",
  jinkai: "天津市津开电力设备制造有限公司",
  kailong: "广州凯隆建材有限公司",
  ronghedingsheng: "广州荣和鼎盛科技有限公司",
  xinjuneng: "深圳市新巨能科技有限公司",
  yongxu: "深圳市永旭兴业科技有限公司",
  feinuoke: "成都市菲诺克科技有限公司",
  tongtaizhongheng: "湖北通泰众恒机电科技有限公司",
  chuanglida: "湖南创立达电气科技有限公司",
  yundan: "湖南省云丹科技有限公司",
  yunqizhongcheng: "四川云起众城科技有限公司",
  botie: "武汉市博铁光电科技有限公司",
  yunbin: "武汉云彬科技有限公司",
  muqing: "襄阳市沐清电气有限公司",
  bofang: "博方电气有限公司",
  derun: "河南德润电气设备销售有限公司",
  huadi: "河南华迪电气有限公司",
  qingbei: "河南清北工业技术有限公司",
  xunxiang: "河南讯翔电气有限公司",
  qingdaoDianqi: "青岛电气设备有限公司",
  shengcheng: "山东晟程清洁能源有限公司",
  tianyiShanxi: "陕西天一电气有限公司",
};

export const [MLwsDealer, OLwsDealer] = convertEnum([
  [ELwsDealer.beisheng, ELwsDealer.beisheng],
  [ELwsDealer.liangxian, ELwsDealer.liangxian],
  [ELwsDealer.rongge, ELwsDealer.rongge],
  [ELwsDealer.yiteng, ELwsDealer.yiteng],
  [ELwsDealer.tianjun, ELwsDealer.tianjun],
  [ELwsDealer.yanzhiyu, ELwsDealer.yanzhiyu],
  [ELwsDealer.huashi, ELwsDealer.huashi],
  [ELwsDealer.hexinda, ELwsDealer.hexinda],
  [ELwsDealer.yixing, ELwsDealer.yixing],
  [ELwsDealer.huayao, ELwsDealer.huayao],
  [ELwsDealer.yingxin, ELwsDealer.yingxin],
  [ELwsDealer.jiacheng, ELwsDealer.jiacheng],
  [ELwsDealer.junwei, ELwsDealer.junwei],
  [ELwsDealer.chengyan, ELwsDealer.chengyan],
  [ELwsDealer.fukang, ELwsDealer.fukang],
  [ELwsDealer.liyang, ELwsDealer.liyang],
  [ELwsDealer.zhongzhida, ELwsDealer.zhongzhida],
  [ELwsDealer.beijingRongqiao, ELwsDealer.beijingRongqiao],
  [ELwsDealer.shenyangRongqiao, ELwsDealer.shenyangRongqiao],
  [ELwsDealer.jinkai, ELwsDealer.jinkai],
  [ELwsDealer.kailong, ELwsDealer.kailong],
  [ELwsDealer.ronghedingsheng, ELwsDealer.ronghedingsheng],
  [ELwsDealer.xinjuneng, ELwsDealer.xinjuneng],
  [ELwsDealer.yongxu, ELwsDealer.yongxu],
  [ELwsDealer.feinuoke, ELwsDealer.feinuoke],
  [ELwsDealer.tongtaizhongheng, ELwsDealer.tongtaizhongheng],
  [ELwsDealer.chuanglida, ELwsDealer.chuanglida],
  [ELwsDealer.yundan, ELwsDealer.yundan],
  [ELwsDealer.yunqizhongcheng, ELwsDealer.yunqizhongcheng],
  [ELwsDealer.botie, ELwsDealer.botie],
  [ELwsDealer.yunbin, ELwsDealer.yunbin],
  [ELwsDealer.muqing, ELwsDealer.muqing],
  [ELwsDealer.bofang, ELwsDealer.bofang],
  [ELwsDealer.derun, ELwsDealer.derun],
  [ELwsDealer.huadi, ELwsDealer.huadi],
  [ELwsDealer.qingbei, ELwsDealer.qingbei],
  [ELwsDealer.xunxiang, ELwsDealer.xunxiang],
  [ELwsDealer.qingdaoDianqi, ELwsDealer.qingdaoDianqi],
  [ELwsDealer.shengcheng, ELwsDealer.shengcheng],
  [ELwsDealer.tianyiShanxi, ELwsDealer.tianyiShanxi],
]);

/**
 * 通用开关 启用 关闭
 */
export const EDisplayStatus = {
  /** 开启 */
  open: 1,

  /** 关闭 */
  close: 2,
};

export const [MDisplayStatus, ODisplayStatus] = convertEnum([
  [EDisplayStatus.open, "开启"],
  [EDisplayStatus.close, "关闭"],
]);

/**
 * 订单状态
 */
export const EApplicationStatus = {
  /** 未处理 */
  Unprocessed: 1,

  /** 已处理 */
  Processed: 2,
};
export const [MOrderStatus, OOrderStatus] = convertEnum([
  [EApplicationStatus.Unprocessed, "待处理"],
  [EApplicationStatus.Processed, "已处理"],
]);

/**
 * 操作日志类型
 */
export const EOperationLog = {
  /** 新增 */
  add: 1,

  /** 修改 */
  modify: 2,
  /** 删除 */
  del: 3,
  /** 导出 */
  export: 4,
  /** 导入 */
  Import: 5,
};
export const [MOperationLog, OOperationLog] = convertEnum([
  [EOperationLog.add, "新增"],
  [EOperationLog.modify, "修改"],
  [EOperationLog.del, "删除"],
  [EOperationLog.export, "导出"],
  [EOperationLog.Import, "导入"],
]);

export const ETypeInfo = {
  /** 富文本 */
  one: 1,
  /** 文件 */
  two: 2,
  /** 压缩包 */
  three: 3,
};
export const [MTypeInfo, OTypeInfo] = convertEnum([
  [ETypeInfo.one, "富文本"],
  [ETypeInfo.two, "文件"],
  [ETypeInfo.three, "压缩包"],
]);

export const EMemberExamine = {
  /** 待审核 */
  PendingReview: 1,
  /** 审核通过 */
  adopt: 2,
  /** 审核拒绝 */
  refuse: 3,
};
export const [MMemberExamine, OMemberExamine] = convertEnum([
  [EMemberExamine.PendingReview, "待审核"],
  [EMemberExamine.adopt, "审核通过"],
  [EMemberExamine.refuse, "审核拒绝"],
]);

export const EQuestionType = {
  /** 单选 */
  single: 1,
  /** 多选 */
  multiple: 2,
};
export const [MQuestionType, OQuestionType] = convertEnum([
  [EQuestionType.single, "单选题"],
  [EQuestionType.multiple, "多选题"],
]);
// 通过未通过
export const EPassStatus = {
  /** 通过 */
  pass: 2,
  /** 未通过 */
  fail: 3,
};
export const [MPassStatus, OPassStatus] = convertEnum([
  [EPassStatus.pass, "通过"],
  [EPassStatus.fail, "未通过"],
]);

/**
 * 盘厂-所在大区
 */
export const ERegion = {
  /** 智能业务拓展上海组 */
  zhinengShanghai: 1,
  /** 智能业务拓展华东组 */
  zhinengHuadong: 2,
  /** 智能业务拓展华南组 */
  zhinengHuanan: 3,
  /** 智能业务拓展华北组 */
  zhinengHuabei: 4,
  /** 智能业务拓展华中组 */
  zhinengHuazhong: 5,
  /** 智能业务拓展华西组 */
  zhinengHuaxi: 6,
  /** 盘厂服务部 */
  panchangService: 7,
};
export const [MRegion, ORegion] = convertEnum([
  [ERegion.zhinengShanghai, "智能业务拓展上海组"],
  [ERegion.zhinengHuadong, "智能业务拓展华东组"],
  [ERegion.zhinengHuanan, "智能业务拓展华南组"],
  [ERegion.zhinengHuaxi, "智能业务拓展华西组"],
  [ERegion.zhinengHuabei, "智能业务拓展华北组"],
  [ERegion.zhinengHuazhong, "智能业务拓展华中组"],
  [ERegion.panchangService, "盘厂服务部"],
]);

/**
 * 盘厂-授权合作类型
 */
export const ECooperateType = {
  /** 良信经销商 */
  dealer: 1,
  /** 良信原合作盘厂 */
  oldFactory: 2,
  /** 地区部资源开发盘厂 */
  districtFactory: 3,
  /** 智拓主导开发盘厂 */
  zhituoFactory: 4,
};
export const [MCooperateType, OCooperateType] = convertEnum([
  [ECooperateType.dealer, "良信经销商"],
  [ECooperateType.oldFactory, "良信原合作盘厂"],
  [ECooperateType.districtFactory, "地区部资源开发盘厂"],
  [ECooperateType.zhituoFactory, "智拓主导开发盘厂"],
]);

/** 盘厂-人员数量 */
export const EStaffCount = {
  less10: 1,
  between10And49: 2,
  between50And99: 3,
  between100And499: 4,
  between500And1000: 5,
  more1000: 6,
};
export const [MStaffCount, OStaffCount] = convertEnum([
  [EStaffCount.less10, "10人以下"],
  [EStaffCount.between10And49, "10~49人"],
  [EStaffCount.between50And99, "50~99人"],
  [EStaffCount.between100And499, "100~499人"],
  [EStaffCount.between500And1000, "500~1000人"],
  [EStaffCount.more1000, "1000人以上"],
]);

/**
 * 会员角色
 */
export const EMemberRole = {
  /** 企业负责人/老板 */
  boss: 1,

  /** 普通员工 */
  employee: 2,
};

export const [MMemberRole, OMemberRole] = convertEnum([
  [EMemberRole.boss, "企业负责人/老板"],
  [EMemberRole.employee, "普通员工"],
]);

